import { render, staticRenderFns } from "./about-cooperation.vue?vue&type=template&id=7aa92024&scoped=true&"
import script from "./about-cooperation.vue?vue&type=script&lang=js&"
export * from "./about-cooperation.vue?vue&type=script&lang=js&"
import style0 from "./about-cooperation.vue?vue&type=style&index=0&id=7aa92024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa92024",
  null
  
)

export default component.exports